import axios from 'axios';

// Create an Axios instance
const instance = axios.create({
  baseURL: 'http://localhost:8000/api/', // Django 서버의 API 주소를 입력하세요
  timeout: 20000,
  headers: {
    'Content-Type': 'application/json',
    // 'Authorization': `Bearer ${localStorage.getItem('token')}`, // JWT 토큰 설정
  },
});

// Request interceptor to add token to headers
instance.interceptors.request.use(config => {
  const token = localStorage.getItem('token'); // JWT 토큰을 로컬 스토리지에서 가져옴
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`; // 요청 헤더에 JWT 토큰 추가
  }
  return config;
}, error => {
  return Promise.reject(error);
});

export default instance;